<!-- START Top Navbar-->
<nav class="navbar topnavbar" role="navigation">
    <!--START navbar header-->
    <div class="navbar-header">
        <a class="navbar-brand" href="#/">
            <div class="brand-logo">
                <img sizes="100%" class="img-fluid" src="assets/img/logo/AGAT.logo.small.png" />
            </div>
            <div class="brand-logo-collapsed">
                <img class="img-fluid" src="assets/img/logo/AGAT.logo.small.png" />
            </div>
        </a>
    </div>
    <!--END navbar header-->
    <!--START Left navbar-->
    <ul class="navbar-nav mr-auto flex-row">
        <li class="nav-item">
            <!--Button used to collapse the left sidebar. Only visible on tablet and desktops-->
            <a class="nav-link d-none d-md-block d-lg-block d-xl-block" #sbbutton trigger-resize="" (click)="toggleCollapsedSideabar()" *ngIf="!isCollapsedText()">
                <em class="fa fa-arrow-left"></em>
            </a>
            <!--Button to show/hide the sidebar on mobile. Visible on mobile only.-->
            <a class="nav-link sidebar-toggle d-md-none"
               #sbbutton
               title='Expand\Collapsed sidebar'
               ngbTooltip='Collapsed\Expand sidebar'
               (click)="settings.toggleLayoutSetting('asideToggled'); $event.stopPropagation()">
                <em class="fa fa-arrow-left">
                </em>
            </a>
        </li>
    </ul>
    <!--END Left navbar-->
    <!--START Right Navbar-->
    <ul class="navbar-nav flex-row">
        <!--Fullscreen (only desktops)-->
        <li class="nav-item d-none d-md-block">
            <a class="nav-link"
               #fsbutton
               (click)="toggleFullScreen($event)">
                <em class="fa fa-expand"></em>
            </a>
        </li>
        <!--START Logout menu-->
        <li class="nav-item">
            <a class="nav-link"
               title="Logout"
               (click)="logout();">
                <em class="icon-logout"></em>
            </a>
        </li>
        <!--END Logout menu-->
    </ul>
    <!--END Right Navbar-->
</nav>
<!-- END Top Navbar-->
